import type { ReactNode } from "react";
import { C, font } from "../theme";
import { Card } from "./Card";
import { Label } from "./Label";
import { Button } from "./Button";

interface ConfirmDialogProps {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  busyLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  cancelLabel = "Cancelar",
  destructive = true,
  busy = false,
  busyLabel = "Processando...",
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(17,17,17,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50,
        padding: 16,
      }}
    >
      <Card style={{ width: "100%", maxWidth: 420 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Label style={{ color: C.ink, fontSize: 13, letterSpacing: 0.5 }}>{title}</Label>
          <Button variant="ghost" onClick={onCancel} ariaLabel="Fechar" style={{ fontSize: 16, lineHeight: 1 }}>
            ✕
          </Button>
        </div>
        <p style={{ fontFamily: font, fontSize: 13.5, color: C.gray, lineHeight: 1.55, margin: "12px 0 18px" }}>{children}</p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button variant="outline" onClick={onCancel} disabled={busy}>{cancelLabel}</Button>
          <Button
            onClick={onConfirm}
            disabled={busy}
            style={destructive ? { background: C.red, color: C.white, border: "none" } : undefined}
          >
            {busy ? busyLabel : confirmLabel}
          </Button>
        </div>
      </Card>
    </div>
  );
}
